module.exports = __webpack_public_path__ + "static/media/btnPrev.5d2663de.svg";